import { AttributeGroup } from 'state/attributeGroup'
// import { Product } from 'state/product'
import { Attribute } from 'state/attribute'
import { classList } from 'MK/DOM/fns/classList'


MK.events.on('attribute:groups:clearAllSelections', (event = {}) => {
  event && event.preventDefault && event.preventDefault()

  // Remove selected attribute breadcrumbs, if any exist.
  while (Attribute.selections.container.firstChild) {
    Attribute.selections.container.removeChild(Attribute.selections.container.firstChild)
  }

  if (event) {
    // AttributeGroup.toggleRefinementMenu()
    // let leftnav = MK.DOM.fns.getElementById('leftnav')
    // if (leftnav.className === 'visible open') {
    //   MK.events.emit('attribute:groups:toggleRefinementMenu')
    // }
    classList.remove(document.body, 'noScroll')
  }

  AttributeGroup.groups.forEach(group => group.clearSelections())

  console.log('############################################################### AttributeGroup.clearAllSelections / Clearing All Selections ###############################################################')
  AttributeGroup.selected = {}
  AttributeGroup.active = {}

  MK.events.emit('products:activate:all', {
    initiator: 'attribute:groups:clearAllSelections'
  })
  // AttributeGroup.updateDOM()
  MK.events.emit('attribute:groups:updateDOM', {
    initiator: 'attribute:groups:clearAllSelections'
  })
})